import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button, Card, CardContent, TextField, Typography, Alert, Divider } from '@mui/material';
import { forgotPassword } from '../../store/actions';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/images/logo.jpg';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    dispatch(forgotPassword(email, (res) => {
      if (res?.code === 200) {
        navigate('/forgot-home');
      } else {
        setError(res?.message || 'Something went wrong');
      }
    }));
  };

  return (
    <Card className="login-card">
      <CardContent className="login-card-content">
        {/* Header */}
        <Box className="login-header">
          <Box className="login-header-icon">
            <img src={logo} alt="Logo" className="admin-login-logo" />
          </Box>
          <Typography variant="h4" className="login-title">
            Admin Portal
          </Typography>
          <Typography variant="body1" className="login-subtitle">
            Reset your password
          </Typography>
        </Box>

        <Divider className="login-divider" />

        {/* Error Alert */}
        {error && (
          <Alert severity="error" className="login-error">
            {error}
          </Alert>
        )}

        {/* Forgot Password Form */}
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            fullWidth
            label="Email Address"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            margin="normal"
            required
            autoComplete="email"
          />
          <Button type="submit" disabled={!email} variant="contained" fullWidth className="login-button" sx={{ mt: 2 }}>
            Send Reset Link
          </Button>
        </Box>

        {/* Back to Login Link */}
        <Box className="login-help">
          <Typography variant="body2">
            Remember your password?{' '}
            <Button
              component="button"
              type="button"
              variant="text"
              onClick={() => navigate('/login')}
              sx={{ p: 0, textTransform: 'none' }}
            >
              Sign in
            </Button>
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ForgotPassword;
